import React, { useState, useRef } from "react";
import { Alert } from "react-bootstrap";

const WordFileUpload = ({ onFileSelect}) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  
  // Using React ref to manage file input trigger
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/msword", // .doc
      "application/pdf", // .pdf
      "text/plain", // .txt
      "application/vnd.ms-powerpoint", // .ppt
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
      "application/vnd.ms-excel", // .xls
      "image/gif", // .gif
      "image/jpeg", // .jpeg
      "image/png", // .png
    ];

    if (selectedFile && validTypes.includes(selectedFile.type)) {
      setFile(selectedFile);
      onFileSelect(selectedFile); // Pass the index and file to the parent
      setError("");
    } else {
      setError("Please upload a valid file type (.doc, .docx, .pdf, .txt, .ppt, .pptx, .xls, .gif, .jpeg, .png).");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const selectedFile = e.dataTransfer.files[0];
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/msword", // .doc
      "application/pdf", // .pdf
      "text/plain", // .txt
      "application/vnd.ms-powerpoint", // .ppt
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
      "application/vnd.ms-excel", // .xls
      "image/gif", // .gif
      "image/jpeg", // .jpeg
      "image/png", // .png
    ];

    if (selectedFile && validTypes.includes(selectedFile.type)) {
      setFile(selectedFile);
      onFileSelect(selectedFile); // Pass the index and file to the parent
      setError("");
    } else {
      setError("Please upload a valid file type (.doc, .docx, .pdf, .txt, .ppt, .pptx, .xls, .gif, .jpeg, .png).");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click(); // Trigger the file input click using ref
  };

  const handleRemoveFile = () => {
    setFile(null);
    setError("");
    onFileSelect(null); // Remove the file
  };

  return (
    <div className="container my-4">
      {error && <Alert variant="danger">{error}</Alert>}

      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={handleClick}
        className="dropzone p-4 text-center border border-primary rounded"
        style={{ cursor: "pointer" }}
      >
        <input
          type="file"
          accept=".doc, .docx, .pdf, .txt, .ppt, .pptx, .xls, .gif, .jpeg, .png"
          onChange={handleFileChange}
          ref={fileInputRef} // Assign the ref to the input
          style={{ display: "none" }}
        />
        {file ? (
          <div className="file-preview mt-3">
            <h6>Selected File:</h6>
            <p className="text-muted">
              {file?.name}
              <button
                type="button"
                className="btn btn-sm btn-danger ms-2"
                onClick={handleRemoveFile}
                style={{
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  padding: 0,
                  fontSize: "12px",
                }}
              >
                ×
              </button>
            </p>
          </div>
        ) : (
          <div className="dropzone-text">
            <i className="fa fa-upload fs-3 mb-2 text-primary"></i>
            <p>
              Drag & Drop a file here, or{" "}
              <span className="text-primary">click to select</span>
            </p>
            <small className="text-muted">Allowed formats: .doc, .docx, .pdf, .txt, .ppt, .pptx, .xls, .gif, .jpeg, .png</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default WordFileUpload;
